module.exports = __webpack_public_path__ + "img/assembly_to_executable.926437cf.png";